import {getApiConfig} from "../../../utilities";

export const generateTwoFaToken = (fabricatorId) => {
  return getApiConfig(`TwoFactorAuthentication/GenerateFabricator2FARequest?fabricatorId=${fabricatorId}`).get();
}

export const sendTwoFaSms = (postData) => {
  return getApiConfig(`TwoFactorAuthentication/SendAuthenticationRequest`).post(postData);
}

export const submitTwoFaCode = (fabricatorId, postData) => {
  return getApiConfig(`TwoFactorAuthentication/ValidateFabricatorAuthenticationRequest?fabricatorId=${fabricatorId}`).post(postData);
}
